import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-table-header',
  templateUrl: './time-table-header.component.html',
  styleUrls: ['./time-table-header.component.scss']
})
export class TimeTableHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
